import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['body']

  // 使用方法: メニュー側のボタン要素にdata-target-id, data-action=collapse#toggle, 隠す部分にid, data-collapse-target=bodyと指定します
  // メニュー要素内にspanで囲まれた要素があればトグル時に上下反転します(arrowマーク的なものを推奨)
  toggle(event) {
    const element = this.bodyTargets.find((el) => {
      return el.id === event.target.closest('button').dataset.targetId
    })
    if (element.classList.contains('hidden')) {
      element.classList.remove('hidden')
      event.target
        .closest('button')
        .getElementsByTagName('span')[0]
        .classList.add('rotate-[-180deg]')
    } else {
      element.classList.add('hidden')
      event.target
        .closest('button')
        .getElementsByTagName('span')[0]
        .classList.remove('rotate-[-180deg]')
    }
  }
}
